import React from 'react'
import { DatePicker } from 'antd'
import type { DatePickerProps } from 'antd'
import dayjs from 'dayjs'

interface InputDateProps extends Partial<Omit<DatePickerProps, 'onChange' | 'value' | 'placeholder'>> {
  value?: string
  onChange?: (value: any) => void
  format?: string
  placeholder?: string
  label?: string | string[]
}

const InputDate: React.FC<InputDateProps> = ({
  value,
  label,
  onChange,
  format = 'YYYY-MM-DD',
  placeholder = 'Select your date',
  ...props
}) => {
  return (
    <div className='xinput-date-custom'>
      <DatePicker
        label={typeof label === 'string' ? label : label?.[0]}
        value={typeof value === 'string' && value ? dayjs(value, format) : null}
        onChange={(date: dayjs.Dayjs | null) => onChange?.(date ? date.format(format) : '')}
        placeholder={typeof placeholder === 'string' ? placeholder : placeholder[0]}
        format={format}
        style={{ width: '100%', ...props.style }}
        className='h-[38px]'
        {...props}
      />
    </div>
  )
}

export default InputDate
